import { CardContainer, VerticalContainer } from "@shared/designSystem/Containers";
import { MilestoneSteps } from "@shared/designSystem/MilestoneSteps";
import { H1Title, H2Title } from "@shared/designSystem/Titles";
import designSystemStyles from "@shared/styles/designSystemStyles";

const MilestoneStepsShowcaseScreen = () => {
    return (
        <VerticalContainer>
            <H1Title text="MilestoneSteps Showcase" />

            <CardContainer>
                <VerticalContainer gap={designSystemStyles.gapSm} alignment="left">
                    <H2Title text="Progress by milestone ID" />
                    <MilestoneSteps
                        ariaLabel="Export process milestones"
                        currentMilestoneId="review"
                        milestones={[
                            { id: "created", title: "Creado" },
                            { id: "processing", title: "Procesando" },
                            { id: "review", title: "Revisión" },
                            { id: "export", title: "Exportación" }
                        ]}
                        description="El proceso está listo para revisar los datos antes de exportarlos."
                    />
                </VerticalContainer>
            </CardContainer>

            <CardContainer>
                <VerticalContainer gap={designSystemStyles.gapSm} alignment="left">
                    <H2Title text="Progress by index" />
                    <MilestoneSteps
                        ariaLabel="Request process milestones"
                        currentMilestoneIndex={1}
                        milestones={[
                            { id: "requested", title: "Solicitado" },
                            { id: "approved", title: "Aprobado" },
                            { id: "processed", title: "Procesado" },
                            { id: "finished", title: "Finalizado" }
                        ]}
                        description="El segundo hito está activo; los hitos previos aparecen completados."
                    />
                </VerticalContainer>
            </CardContainer>
        </VerticalContainer>
    );
};

export default MilestoneStepsShowcaseScreen;
